import React from "react";
import { OrangeTextButton } from "../../common/OrangeTextButton";
import { TextField } from "@mui/material";
import {
  OnboardingProgressDiv,
  isCameraCheckSupported,
} from "../Onboarding/OnboardingProgressDiv";
import ErrorBoundary from "../../../ErrorBoundary";

export const DiceSetupScreen = ({
  setVisibleScreen,
}: {
  setVisibleScreen: any;
}) => {
  const [postObject, setPostObject] = React.useState({
    id: -1,
    dice_server: "",
    dice_port: "",
  });

  return (
    <ErrorBoundary>
      <div>
        <p
          className={
            "font-mulish absolute top-[90px] w-[300px] font-bold text-[#283E6D] left-[25px] text-[16px]"
          }
        >
          {`Dice Alert Information`}
        </p>
        <div className="pt-[140px] pl-[30px]">
          <TextField
            value={postObject.dice_server}
            id="dice_server"
            variant="standard"
            label="Dice Server"
            onChange={(event) => {
              setPostObject((previousState: any) => {
                return { ...previousState, dice_server: event.target.value };
              });
            }}
            sx={{ width: "400px" }}
            helperText="What is the url for your dice server."
            type="string"
          />
          <br></br>
          <br></br>
          <TextField
            value={postObject.dice_port}
            id="dice_port"
            variant="standard"
            label="Dice Port"
            onChange={(event) => {
              setPostObject((previousState: any) => {
                return { ...previousState, dice_port: event.target.value };
              });
            }}
            sx={{ width: "400px" }}
            helperText="What is the port for your dice server."
            type="string"
          />
        </div>
        <div className="pt-10 pl-[420px]">
          <div style={{ display: "flex" }}>
            &nbsp;&nbsp;&nbsp;
            <OrangeTextButton
              onClick={() => {
                localStorage.setItem(
                  "diceAlertPostObject",
                  JSON.stringify(postObject)
                );
                setVisibleScreen(
                  <OnboardingProgressDiv
                    percentage={
                      isCameraCheckSupported()
                        ? localStorage.healthMonitoringOnly === "true"
                          ? 33
                          : 25
                        : 33
                    }
                    step={1}
                    setVisibleScreen={setVisibleScreen}
                  />
                );
              }}
              text="Submit"
              disabled={!postObject.dice_port || !postObject.dice_server}
            />
          </div>
        </div>
      </div>
    </ErrorBoundary>
  );
};
